module.exports = "pegasus/assets/background-patterns/subtle-white-mini-waves.png";